import axios from 'axios'
// import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn" //接口API
const url = {
  getSudentTask: `${root}/Stutask/getSudentTask`, // 任务中心->获取学生最新任务
  getSudentHistoryTask: `${root}/Stutask/getSudentHistoryTask`, // 任务中心->获取学生历史任务列表
  getHistoryTask: `${root}/Stutask/getHistoryTask`, // 任务中心->获取学生历史任务明细
  getMapsStepsMedias: `${root}/Goover/getMapsStepsMedias`,

}
const loginStore = {
  // 任务中心->获取学生最新任务
  getSudentTask(params :any) {
    return axios.get(url.getSudentTask, { params })
  },
  // 任务中心->获取学生历史任务列表
  getSudentHistoryTask(params :any) {
    return axios.get(url.getSudentHistoryTask, { params })
  },
  // 任务中心->获取学生历史任务明细
  getHistoryTask(params :any) {
    return axios.get(url.getHistoryTask, { params })
  },
  getMapsStepsMedias(params :any) {
    return axios.get(url.getMapsStepsMedias, { params })
  },
}

export default loginStore;